<template>
  <el-dialog
    title="个人资料"
    :visible.sync="dialogVisible"
    width="40%"
    top="20%"
    custom-class="customer-dialog"
    :before-close="closeDialog">
    <table id="customer_table" align="center" style="font-size: 15px;">
      <tr>
        <td align="left">姓名</td>
        <td align="left">{{customer.customerName}}</td>
      </tr>
      <tr>
        <td align="left">编号</td>
        <td align="left">{{customer.customerNo}}</td>
      </tr>
      <tr>
        <td align="left">手机号</td>
        <td align="left">{{customer.mobile}}</td>
      </tr>
      <tr>
        <td align="left">单位名称</td>
        <td align="left">{{customer.enterpriseName}}</td>
      </tr>
    </table>
  </el-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
  props: ['dialogVisible'],
  data () {
    return {
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    ...mapState(['customerInfo']),
    customer () {
      if (this.customerInfo && this.customerInfo !== null) {
        return this.customerInfo
      }
      return {}
    }
  }
}
</script>
<style>
  #customer_table {
    border-spacing: 10px;
  }
  .customer-dialog .el-dialog__body {
    padding: 20px 20px 40px;
    border: solid 1px gainsboro;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/UserInfo.vue